import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { commonModules } from "src/app/app.config";
import { BaseFormComponent } from "src/app/components/base-classes/base-form-component";
import { UserRole, Venue } from "src/app/planvue-api";

export interface DisplayedVenue {
  name: string;
  id: number;
  selected: boolean;
}

export interface UserForm {
  first_name: FormControl<string | null>;
  last_name: FormControl<string | null>;
  email: FormControl<string | null>;
  organization: FormControl<string | null>;
  role: FormControl<UserRole | null>;
  active: FormControl<boolean | null>;
  venues: FormControl<number[] | null>;
  expiration_date: FormControl<Date | null>;
}

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrl: './user-form.component.scss',
  standalone: true,
  imports: [...commonModules, MatDatepickerModule, MatNativeDateModule],
})
export class UserFormComponent extends BaseFormComponent<UserForm> implements OnChanges {
  @Input()
  venues?: DisplayedVenue[] = [];

  @Input()
  permitVenueAssignment = false;

  @Input()
  showAssignedVenues = false;

  @Input()
  assignedVenues: Venue[] = []

  @Input()
  allowedRoles = [
    {
      label: "Lite",
      value: "lite"
    },
    {
      label: "Admin",
      value: "admin"
    }, {
      label: "Power",
      value: "power"
    }, {
      label: "User",
      value: "user"
    }]

  constructor() {
    super();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['venues'] && changes['venues'].currentValue) {
      this.assignedVenues = this.venues!.filter(v => v.selected).map(v => {
        return {
          id: v.id,
          name: v.name
        }
      })
    }
  }
}
